module.exports = __webpack_public_path__ + "fonts/Arvo.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Arvo.ttf
// module id = 1115
// module chunks = 0